import 'instantsearch.css/themes/algolia.css';

import React, { Component } from 'react'
import { Modal } from 'antd'
import { Tabs, Spin, Alert } from 'antd';

import logic from './logic'

import SearchBox from './search-box'
import ProductSearch from './products'
import OrderSearch from './orders'

const TabPane = Tabs.TabPane;

@logic
export default class Search extends Component {

  handleOk = (e) => {
    const { hide } = this.props.actions;

    hide();
  };
  handleCancel = (e) => {
    const { hide } = this.props.actions;

    hide();
  };

  handleChangeTab = (key) => {
    const { changeTab } = this.props.actions;

    changeTab(key);
  };

  render() {
    const {
      visible,
      activeShop,
      productSearchConfig,
      orderSearchConfig,
      searchValue,
      activeTab,
      initializeFailed,
      isInitialized
    } = this.props;
    const { search, clear } = this.props.actions;

    return (
      <Modal
        title="Search"
        visible={ visible }
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        style={{ top: 20 }}
        footer={ null }
      >
        { initializeFailed ?
          <Alert message="Unable to initialize search. Please try again later." type="error" />
          :
          <div>
            { visible ?
              <Spin spinning={ !isInitialized }>
                <SearchBox
                  size="large"
                  placeholder="Type your query"
                  value={ searchValue }
                  onChange={ (e) => {
                    search(e.currentTarget.value);
                  }}
                  onClear={ (e) => {
                    clear();
                  }}
                />
              </Spin>
              : null }
            { searchValue ?
              <Tabs activeKey={ activeTab } onChange={ this.handleChangeTab }>
                <TabPane tab="Products" key="products">
                  { productSearchConfig ?
                    <ProductSearch
                      productSearchConfig={ productSearchConfig }
                      searchQuery={ searchValue }
                    /> : null
                  }
                </TabPane>
                <TabPane tab="Orders" key="orders">
                  { orderSearchConfig ?
                    <OrderSearch
                      orderSearchConfig={ orderSearchConfig }
                      searchQuery={ searchValue }
                    />
                    : null }
                </TabPane>
              </Tabs>
              : '' }
          </div>
        }

      </Modal>
    )
  }
}